import CaretUp from "../images/caret-small.svg?react";

/**Default: 20px by 20px */
export default function CoreCaretIcon({
	height = 20,
	width = 20,
	color = "#6f6f6f",
	direction = "up",
	ariaHidden = "true",
}: {
	width?: string | number;
	height?: string | number;
	/**@default "#6f6f6f" */
	color?: string;
	direction?: "up" | "down" | "left" | "right";
	ariaHidden?: "true" | "false";
}) {
	let transform = "";
	switch (direction) {
		case "down":
			transform = "rotate(180deg)";
			break;
		case "left":
			transform = "rotate(-90deg)";
			break;
		case "right":
			transform = "rotate(90deg)";
			break;
		default:
			transform = "rotate(0deg)";
	}
	return <CaretUp width={width} height={height} color={color} style={{ transform }} aria-hidden={ariaHidden} />;
}
